import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import cx from 'classnames';

import { Content } from 'LegacySBCRA/Content/Content';

import VehicleImage from '../../../../../components/misc/VehicleImage/VehicleImage';
import { HeroFrameAnimation } from '../../../common/Hero/HeroFrameAnimation/HeroFrameAnimation';
import { useHeroHelpers } from '../../../common/Hero/Hooks/useHeroHelpers';
import Breadcrumbs from '../../../fastlane/breadcrumbs/Breadcrumbs';
import ChevronAnimation from '../../../fastlane/chevronAnimation/ChevronAnimation';

import { HeroVRM } from './SubComponents/HeroVRM/HeroVRM';

import styles from './Hero.scss';

export type HeroProps = {
  onLoad?: () => void;
  subTitle?: string;
  title?: string;
};

export const Hero = ({ onLoad, subTitle, title }: HeroProps) => {
  const container = useRef<HTMLInputElement>(null);
  const [cssVars, setCssVars] = useState({});

  const {
    isAnimatingMileageTransition,
    isAnimatingVrmTransition,
    isMileageTransition,
    loading,
    loadingHandler,
    minHeight,
    prevIsAnimatingMileageTransition,
    setIsAnimatingMileageTransition,
    setIsAnimatingVrmTransition,
  } = useHeroHelpers({ animateFromHomePage: true, container });

  useEffect(() => onLoad?.(), []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isMileageTransition) {
      setCssVars({
        '--lock-opacity-delay': '0.5s',
        '--vrm-input-opacity-delay': '0.5s',
      });
    }
  }, [isMileageTransition]);

  const mileageTransitionStyles = {
    [styles.mileageTransition]: prevIsAnimatingMileageTransition || isMileageTransition,
  };

  return (
    <>
      <div className={cx(
        styles.visibleWrapper,
        mileageTransitionStyles,
      )}>
        {isMileageTransition && (
          <HeroFrameAnimation
            isAnimating={isAnimatingMileageTransition}
            setIsAnimating={setIsAnimatingMileageTransition}
          />
        )}

        <div className={styles.contentWrapper}>
          <ChevronAnimation
            isTransition={isMileageTransition}
            loading={isAnimatingVrmTransition || isAnimatingMileageTransition}
            setAnimationInProgress={setIsAnimatingVrmTransition}
          />
          <div
            className={styles.component}
            style={{ ['--hero-min-height' as string]: minHeight }}
          >
            <Content className={styles.breadcrumbWrapper}>
              <Breadcrumbs onYellow />
            </Content>
            <div ref={container} className={styles.vrmContainer} style={cssVars}>
              <HeroVRM
                {...{
                  loadingHandler,
                  subTitle,
                  title,
                }}
                inProgress={isAnimatingVrmTransition || isAnimatingMileageTransition || Boolean(loading)}
              />
            </div>
          </div>
          {isMileageTransition && <div className={styles.bottomHeroArrow} />}
        </div>

        <VehicleImage className={cx(styles.vehicleSilver, styles.vehicleImage, mileageTransitionStyles)} name='silverbackdrop' />
        <VehicleImage className={cx(styles.vehicleBlack, styles.vehicleImage, mileageTransitionStyles)} name='blackbackdrop' />
      </div>
    </>
  );
};
